module.exports = __webpack_public_path__ + "img/weddings_14_V.4225f481.webp";